import * as l from "react";
import { p as e } from "./index-efd35e77.js";
import { v as D, l as c, m as L, c as R, p as h } from "./package-metadata-3dcf116a.js";
import { S as x } from "./index-93802845.js";
var d = function(a) {
  D(h);
  var m = a.id, f = a.editorId, t = a.editorRef, i = a.editorDisabled, r = a.children, b = a.editorValid, u = a.style, p = a.className, v = a.optional, k = x(), o = v ? k.toLanguageString(c, L[c]) : "", y = o && l.createElement("span", { className: "k-label-optional" }, o), g = l.useCallback(function(s) {
    if (t && t.current && !i) {
      t.current.focus && (s.preventDefault(), t.current.focus());
      var n = t.current.actionElement;
      n && (s.preventDefault(), n.click());
    }
  }, [t]), N = R({
    "k-label": !0,
    "k-label-empty": !r,
    "k-text-error": b === !1,
    "k-text-disabled": i === !0
  }, p);
  return l.createElement(
    "label",
    { id: m, htmlFor: f, onClick: g, style: u, className: N },
    r,
    y
  );
};
d.propTypes = {
  id: e.string,
  editorId: e.string,
  editorRef: e.oneOfType([
    e.func,
    e.shape({ current: e.any })
  ]),
  editorValid: e.bool,
  editorDisabled: e.bool,
  style: e.object,
  className: e.string,
  optional: e.bool
};
d.displayName = "KendoReactLabel";
export {
  d as L
};
